var _style, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderfloorHeatingManifold01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;fill:#FFFFFF}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.2,
    className: "st0",
    width: 9,
    height: 5.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderfloorHeatingManifold01);
export default __webpack_public_path__ + "static/media/UnderfloorHeatingManifold-01.d14ae6f88bfa79f3fc69e33f02da99b3.svg";
export { ForwardRef as ReactComponent };